var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeAllTierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35311 6.14663C7.39967 6.19308 7.43661 6.24825 7.46182 6.309C7.48703 6.36974 7.5 6.43486 7.5 6.50063C7.5 6.5664 7.48703 6.63152 7.46182 6.69226C7.43661 6.75301 7.39967 6.80819 7.35311 6.85463L1.3531 12.8546C1.25922 12.9485 1.13188 13.0013 0.999105 13.0013C0.866329 13.0013 0.738992 12.9485 0.645105 12.8546C0.551218 12.7607 0.498474 12.6334 0.498474 12.5006C0.498474 12.3679 0.551218 12.2405 0.645105 12.1466L6.29211 6.50063L0.645105 0.854631C0.551219 0.760745 0.498474 0.633407 0.498474 0.500631C0.498474 0.367856 0.551219 0.240518 0.645105 0.146631C0.738992 0.0527447 0.86633 -2.89967e-07 0.999105 -2.84163e-07C1.13188 -2.78359e-07 1.25922 0.0527447 1.35311 0.146631L7.35311 6.14663Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeAllTierIcon);
export default __webpack_public_path__ + "static/media/see-all-tier-icon.174fbc0f1de37ac61693cb31b29ebfb5.svg";
export { ForwardRef as ReactComponent };